import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import StoppagesTable from "./_elements/StoppagesTable";
import vdmDashboardSelectors from "redux/app/vdmdashboard/selectors";
import { Tooltip } from "react-tippy";

const smallSegmentPercent = 4.9;

type OwnProps = {
	vesselId: string;
};
type VDMDashboardStoppagesProps = PropsFromRedux & OwnProps;
function VDMDashboardStoppages(props: VDMDashboardStoppagesProps) {
	const { stoppageSummary, stoppages } = props;
	const planned = stoppageSummary?.plannedHours;
	const unplanned = stoppageSummary?.unplannedHours;
	const other = stoppageSummary?.otherHours;
	const total =
		stoppageSummary?.totalHours ??
		(planned ?? 0) + (unplanned ?? 0) + (other ?? 0);

	const plannedPercentage = ((planned ?? 0) / total) * 100;
	const unplannedPercentage = ((unplanned ?? 0) / total) * 100;
	const otherPercentage = ((other ?? 0) / total) * 100;

	const tooltipContent = (
		<div className="flex flex-col gap-1 p-1">
			<div className="flex items-center gap-2">
				<span className="w-3 h-3 rounded-sm bg-blue-500 inline-block" />
				<span>
					Planned: <strong>{planned ?? 0}hrs</strong>
				</span>
			</div>
			<div className="flex items-center gap-2">
				<span className="w-3 h-3 rounded-sm bg-orange-400 inline-block" />
				<span>
					Unplanned: <strong>{unplanned ?? 0}hrs</strong>
				</span>
			</div>
			<div className="flex items-center gap-2">
				<span className="w-3 h-3 rounded-sm bg-gray-400 inline-block" />
				<span>
					Other: <strong>{other ?? 0}hrs</strong>
				</span>
			</div>
		</div>
	);

	return (
		<div className="mt-4">
			{!total || total === 0 ? null : (
				<Tooltip
					html={tooltipContent}
					position="bottom"
					trigger="mouseenter"
					arrow
					theme="light"
					className="w-full"
				>
					<div className="flex w-full h-10 bg-gray-200 rounded-md overflow-hidden shadow-inner cursor-pointer">
						{/* Planned */}
						{!!planned && planned > 0 && (
							<div
								className="flex items-center justify-center bg-blue-500 transition-all duration-500"
								style={{ width: `${plannedPercentage}%` }}
							>
								<span className="text-white font-medium text-sm md:text-base px-2 truncate">
									{plannedPercentage > smallSegmentPercent
										? `Planned - ${planned}hrs`
										: `${planned}hrs`}
								</span>
							</div>
						)}

						{/* Unplanned */}
						{!!unplanned && unplanned > 0 && (
							<div
								className="flex items-center justify-center bg-orange-400 transition-all duration-500"
								style={{ width: `${unplannedPercentage}%` }}
							>
								<span className="text-black font-medium text-sm md:text-base px-2 truncate">
									{unplannedPercentage > (smallSegmentPercent + 10)
										? `Unplanned - ${unplanned}hrs`
										: `${unplanned}hrs`}
								</span>
							</div>
						)}

						{/* Other */}
						{!!other && other > 0 && (
							<div
								className="flex items-center justify-center bg-gray-400 transition-all duration-500"
								style={{ width: `${otherPercentage}%` }}
							>
								<span className="text-white font-medium text-sm md:text-base px-2 truncate">
									{otherPercentage > smallSegmentPercent
										? `Other - ${other}hrs`
										: `${other}hrs`}
								</span>
							</div>
						)}
					</div>
				</Tooltip>
			)}

			<div className="mt-4">
				<StoppagesTable stoppages={stoppages} />
			</div>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vdmDashboardStore = vdmDashboardSelectors._getStore(store);
	const vdmDashboardContent =
		vdmDashboardSelectors.getVDMDashboardContent(vdmDashboardStore);
	const stoppageSummary = vdmDashboardContent?.stopaggesSummary;
	const stoppages = vdmDashboardContent?.stopagges;
	return {
		stoppages,
		stoppageSummary,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VDMDashboardStoppages);
